import { useEffect, useCallback, useState } from 'react';
import { fg } from '@atlassian/jira-feature-gating';
import { getFlags, setFlag } from '@atlassian/jira-common-have-i-seen-it/src/index.tsx';
import type { HaveISeenItFlags } from '@atlassian/jira-common-have-i-seen-it/src/types.tsx';

const TTL_SEEN = 1000 * 60 * 60 * 24 * 365; // ~ 365 days

const SEEN_ONBOARDING = 'saved-filters-menu';

// Delete when cleaning up jira-issue-navigator-saved-filters-menu or nin-saved-filters-menu-onboarding
export const useFiltersMenuSpotlightOnboarding = () => {
	const [isOnboardingVisible, setIsOnboardingVisible] = useState(false);

	useEffect(() => {
		if (!fg('nin-saved-filters-menu-onboarding')) {
			return;
		}

		if (__SERVER__) {
			return;
		}

		getFlags({
			[SEEN_ONBOARDING]: {},
		})
			.then((seenItResponse: HaveISeenItFlags) => {
				const isOnboardingSeen = seenItResponse[SEEN_ONBOARDING]?.status;
				if (isOnboardingSeen !== true) {
					setIsOnboardingVisible(true);
				}
			})
			.catch(() => {
				// Ignore errors
			});
	}, []);

	const markAsSeen = useCallback(() => {
		setIsOnboardingVisible(false);
		setFlag(SEEN_ONBOARDING, TTL_SEEN);
	}, []);

	return [isOnboardingVisible, markAsSeen] as const;
};
